
/**
 * @export
 * @enum {string}
 */
export enum UserEventCode {
    ACCOUNT_CREATE_OPEN = 'ACCOUNT_CREATE_OPEN',
    ACCOUNT_CREATE_SUBMIT = 'ACCOUNT_CREATE_SUBMIT',
    ACCOUNT_FIELD_CHANGE = 'ACCOUNT_FIELD_CHANGE',
    ACCOUNT_PROFILE_OPEN = 'ACCOUNT_PROFILE_OPEN',
    ACCOUNT_SUBMIT = 'ACCOUNT_SUBMIT',
    ACCOUNT_TAB_CHANGE = 'ACCOUNT_TAB_CHANGE',
    BULK_ACTION_DOWNLOAD = 'BULK_ACTION_DOWNLOAD',
    BULK_ACTION_OPEN = 'BULK_ACTION_OPEN',
    BULK_ACTION_SUBMIT = 'BULK_ACTION_SUBMIT',
    GROUP_CHANGE = 'GROUP_CHANGE',
    GROUP_DELETE = 'GROUP_DELETE',
    GROUP_OPEN = 'GROUP_OPEN',
    GROUP_SUBMIT = 'GROUP_SUBMIT',
    LICENSE_CREATE_CHANGE = 'LICENSE_CREATE_CHANGE',
    LICENSE_CREATE_OPEN = 'LICENSE_CREATE_OPEN',
    LICENSE_CREATE_SUBMIT = 'LICENSE_CREATE_SUBMIT',
    LOGOUT = 'LOGOUT',
    ROLES_OPEN = 'ROLES_OPEN',
    ROLE_CREATE = 'ROLE_CREATE',
    ROLE_DELETE = 'ROLE_DELETE',
    ROLE_OPEN = 'ROLE_OPEN',
    ROLE_UPDATE = 'ROLE_UPDATE',
    SEARCH_CRITERIA_ACCOUNT_CHANGE = 'SEARCH_CRITERIA_ACCOUNT_CHANGE',
    SEARCH_CRITERIA_OPEN = 'SEARCH_CRITERIA_OPEN',
    SEARCH_CRITERIA_RUN = 'SEARCH_CRITERIA_RUN',
    SEARCH_CRITERIA_USER_CHANGE = 'SEARCH_CRITERIA_USER_CHANGE',
    SEARCH_DOWNLOAD = 'SEARCH_DOWNLOAD',
    UNSAVED_CHANGES = 'UNSAVED_CHANGES',
    USER_CREATE_OPEN = 'USER_CREATE_OPEN',
    USER_CREATE_SUBMIT = 'USER_CREATE_SUBMIT',
    USER_FIELD_CHANGE = 'USER_FIELD_CHANGE',
    USER_IMPORT_CONTENT_OPEN = 'USER_IMPORT_CONTENT_OPEN',
    USER_IMPORT_CONTENT_SUBMIT = 'USER_IMPORT_CONTENT_SUBMIT',
    USER_PROFILE_OPEN = 'USER_PROFILE_OPEN',
    USER_ROLE_UPDATE = 'USER_ROLE_UPDATE',
    USER_TAB_CHANGE = 'USER_TAB_CHANGE',
    USER_SUBMIT = 'USER_SUBMIT',
    LOGIN_LINK_GENERATOR_OPEN = 'LOGIN_LINK_GENERATOR_OPEN',
    LOGIN_LINK_GENERATOR_DOWNLOAD = 'LOGIN_LINK_GENERATOR_DOWNLOAD',
    ACCOUNT_REPORT_RUN = 'ACCOUNT_REPORT_RUN',
    ENT_OPEN = 'ENT_OPEN',
    ENT_CR_OPEN = 'ENT_CR_OPEN',
    ENT_CR_SUBMIT = 'ENT_CR_SUBMIT',
    ENT_ER_OPEN = 'ENT_ER_OPEN',
    ENT_ER_SUBMIT = 'ENT_ER_SUBMIT',
    ENT_CG_OPEN = 'ENT_CG_OPEN',
    ENT_CG_SUBMIT = 'ENT_CG_SUBMIT',
    ENT_EG_OPEN = 'ENT_EG_OPEN',
    ENT_EG_SUBMIT = 'ENT_EG_SUBMIT',
    ENT_CRES_OPEN = 'ENT_CRES_OPEN',
    ENT_CRES_SUBMIT = 'ENT_CRES_SUBMIT',
    ENT_ERES_OPEN = 'ENT_ERES_OPEN',
    ENT_ERES_SUBMIT = 'ENT_ERES_SUBMIT',
    CC_OPEN = 'CC_OPEN',
    CC_SUBMIT = 'CC_SUBMIT',
    ET_LAYOUT_SELECT = 'ET_LAYOUT_SELECT',
    ET_CREATE_LAYOUT_SUBMIT = 'ET_CREATE_LAYOUT_SUBMIT',
    ET_RENAME_LAYOUT_SUBMIT = 'ET_RENAME_LAYOUT_SUBMIT',
    ET_REMOVE_LAYOUT_SUBMIT = 'ET_REMOVE_LAYOUT_SUBMIT',
    ET_EDIT_COLUMNS_SUBMIT = 'ET_EDIT_COLUMNS_SUBMIT',
    ET_EDIT_SORTING_SUBMIT = 'ET_EDIT_SORTING_SUBMIT',
    LA_SUBMIT = 'LA_SUBMIT',
    ACCOUNT_AL_FILTER_SUBMIT = 'ACCOUNT_AL_FILTER_SUBMIT',
    USER_CONTENT_TAB_CHANGE = 'USER_CONTENT_TAB_CHANGE',
    ADMIN_MCP_TOKEN_REFRESH = 'ADMIN_MCP_TOKEN_REFRESH',
    ADMIN_MCP_TOKEN_STATUS_CHANGE = 'ADMIN_MCP_TOKEN_STATUS_CHANGE',
    ADMIN_MCP_CONTR_UPDATE = 'ADMIN_MCP_CONTR_UPDATE',
    ADMIN_MCP_CONTR_CREATE = 'ADMIN_MCP_CONTR_CREATE',
    ADMIN_MCP_ACCESS_TGL = 'ADMIN_MCP_ACCESS_TGL'
}